import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from 'oidc-react'

function SignIn({ screenHint, providerHint, isAddIdentity }) {
  const { signIn, signOut, userManager } = useAuth()
  const hasSignedInRef = useRef(false)

  // Extract returnUrl from query parameters and store in localStorage
  const params = new URLSearchParams(useLocation().search)
  const returnUrl =
    params.get('returnUrl') || params.get('returnTo') || params.get('callback')
  localStorage.setItem('returnUrl', returnUrl || '')

  const invite = params.get('invite')

  const extraQueryParams = userManager.settings.extraQueryParams
  extraQueryParams.screen_hint = screenHint
  extraQueryParams.invite = invite
  if (isAddIdentity) {
    extraQueryParams.skip_account_signup = 'true'
  }

  extraQueryParams.provider_hint =
    providerHint ||
    params.get('id_type') ||
    params.get('provider_hint') ||
    params.get('provider')

  if (!isAddIdentity) {
    // clean up addIdentityToken, it's only used once when explicitly adding an identity
    localStorage.removeItem('addIdentityToken')
    localStorage.removeItem('isAddIdentity')
  }

  useEffect(() => {
    if (hasSignedInRef.current) {
      return
    }

    async function signOutAndSignIn() {
      await signOut()
      await signIn({
        extraQueryParams: extraQueryParams,
      })
    }

    signOutAndSignIn()
    hasSignedInRef.current = true
  }, [signIn, signOut])

  return (
    <div>
      <p>Redirecting for sign in...</p>
    </div>
  )
}

export default SignIn
